import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

const FRIENDLY = {
  502: "सर्वर से संपर्क नहीं हो पाया, कृपया कुछ देर बाद फिर कोशिश करें। / Could not reach the server, please try again shortly.",
  503: "सेवा अभी व्यस्त है, कृपया कुछ देर बाद फिर कोशिश करें। / Service is busy, please try again in a few minutes.",
  504: "अनुरोध में बहुत समय लगा, कृपया फिर कोशिश करें। / The request timed out, please try again.",
};

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const res = error?.response;
    if (res?.status === 503 && res.data?.maintenance) {
      window.dispatchEvent(new Event("af:maintenance"));
    }
    if (res && (typeof res.data !== "object" || res.data === null || typeof res.data.detail !== "string")) {
      res.data = { detail: FRIENDLY[res.status] || `कुछ गड़बड़ हो गई (${res.status})। / Something went wrong (${res.status}).` };
    }
    return Promise.reject(error);
  }
);

export { API };
